import OutType from "../../enums/OutType.js";

// @see https://www.mlb.com/glossary/standard-stats/pickoff
// @see https://baseball.fandom.com/wiki/Pickoff
// A pickoff occurs between pitches when a pitcher throws a ball to a fielder, who eventually puts out or assists in retiring an opposing baserunner. 
const classifiesAsPickoff = function(outType) {
    switch (outType) {
        case OutType.Pickoff.key:
            return true;

        default:
            return false;
    }
};

export default classifiesAsPickoff;